import type { Crumb } from "@/lib/seo";

/** Visible breadcrumb trail; Home is prepended, the last crumb is the current page. */
export function Breadcrumbs({ crumbs, tone = "light", className = "" }: { crumbs: Crumb[]; tone?: "light" | "dark"; className?: string }) {
  const all = [{ name: "Home", path: "/" }, ...crumbs];
  const base = tone === "dark" ? "text-cream/70" : "text-charcoal/70";
  const current = tone === "dark" ? "text-cream" : "text-moss";
  const hover = tone === "dark" ? "hover:text-cream" : "hover:text-moss";
  return (
    <nav aria-label="Breadcrumb" className={`mb-8 text-xs uppercase tracking-[0.2em] ${base} ${className}`}>
      <ol className="flex flex-wrap items-center gap-2">
        {all.map((c, i) => {
          const last = i === all.length - 1;
          return (
            <li key={c.path} className="flex items-center gap-2">
              {i > 0 && <span aria-hidden>/</span>}
              {last ? <span aria-current="page" className={current}>{c.name}</span> : <a href={c.path} className={hover}>{c.name}</a>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
